import Landing from "./components/Landing/Landing";
import "./styles/main.scss";

function App() {
	return <Landing />;
}

export default App;
